module.exports = __webpack_public_path__ + "img/2024-03-19f_2.a474d981.jpg";